import Crud from '../views/Center/Crud'
import Entity from '../views/Center/Add'

let routes = {
    path: '/centers',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/centers/add',
            name: 'NewCenter',
            component: Entity,
            meta: {
                pageTitle: 'Central',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/centers'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/centers/edit/:id?',
            name: 'EditCenter',
            component: Entity,
            meta: {
                pageTitle: 'Central',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/centers'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/centers',
            name: 'list-centers',
            component: Crud,
            meta: {
                pageTitle: 'Centrals',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
